import React, {useEffect, useState} from 'react'
import {CardTitle, Col, FormGroup, Label} from "reactstrap";
import Switch from "react-bootstrap-switch";
import {useSelector} from "react-redux";
import {getStateByPath} from "../../../../redux/selectors";
import {udnService} from "../../../../jwt/_services";
import NonRecurringPromotion from "./NonRecurringPromotion";
import RecurringPromotion from "./RecurringPromotion";

import '../../../../assets/css/Schedules.css'


const SchedulePromotion = (props) => {
    const {udn, onChangeData, path} = props
    const componentState = useSelector(state => getStateByPath(state, props.path));

    const { domainObject } = componentState?.data;



    const [isRecurring, setIsRecurring] = useState(domainObject?.isRecurring || false);


    const [udnDetails, setUdnDetails] = useState({})

    const [loadingUdnDetails, setLoadingUdnDetails] = useState(false)
    





    useEffect(() => {
        loadUndDetails()
    }, [udn]);


    const loadUndDetails = () => {
        if(!udn) return;


        setLoadingUdnDetails(true)

        udnService.getItem(udn?.id, null)
            .then( response => {
                setUdnDetails(response)
            }).catch( err => {
                console.error(err)
            } ).finally(() => setLoadingUdnDetails(false))
    }


    const onIsRecurringChange = ({state:{value}}) => {
        setIsRecurring(value)
        onChangeData('IS_RECURRING', value)

        // Si cambia de valor y se trata de un nuevo registro, limpiar los horarios.
        if(!domainObject) {
            onChangeData('SCHEDULE', [])
            return
        }

        // si se trata de la edición de una promoción a recurrente, conservar los valores originales del registro
        if(value)
            onChangeData('SCHEDULE', domainObject?.schedules || [])
        //else  // si se trata de la edición de una promoción a no recurrente, conservar solo el primer valor del registro
            //onChangeData('SCHEDULE', domainObject?.schedules?.length > 0 ? [domainObject?.schedules[0]] : [])
    }


    return <>
        <CardTitle className="bg-light border-bottom p-3 mb-2em">
            Programación de la promoción
        </CardTitle>

        <FormGroup row>
            <Label sm={6}>{'¿Es una promoción recurrente?'}</Label>
            <Col>
                <Switch
                    animate={true}
                    onText={"Si"}
                    offText={"No"}
                    value={isRecurring}
                    onChange={onIsRecurringChange}
                />
            </Col>
        </FormGroup>


        {
            isRecurring
                ? <RecurringPromotion
                    path={path}
                    udn={udnDetails}
                    onChangeData={onChangeData}
                /> : <NonRecurringPromotion
                    path={path}
                    udn={udnDetails}
                    onChangeData={onChangeData}
                />
        }
    </>
}


export default SchedulePromotion